import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import Footer from '../components/layout/Footer';
import SuggestedCourseList from '../components/planner/SuggestedCourseList';
import { useToast } from '../components/common/Toast';
import { useSelection } from '../context/SelectionContext';
import { clearStoredSelections } from '../hooks/useSuggestedCourses';

export default function Planner() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { success, warning } = useToast();
  const { selectedChild } = useSelection();
  const hasShownToast = useRef(false);

  // Handle payment redirect
  useEffect(() => {
    const payment = searchParams.get('payment');

    if (payment && !hasShownToast.current) {
      hasShownToast.current = true;

      if (payment === 'success') {
        // Clear saved selections after successful payment
        if (selectedChild?.id) {
          clearStoredSelections(selectedChild.id);
        }
        success('Payment successful! Your course enrollment has been confirmed.', { duration: 5000 });
      } else if (payment === 'cancelled') {
        warning('Payment was cancelled. Your course selections have been saved.', { duration: 5000 });
      }

      // Clear URL params
      setSearchParams({});
    }
  }, [searchParams, setSearchParams, success, warning, selectedChild]);

  return (
    <main className="h-full flex-1 overflow-y-auto overscroll-contain">
      <div className="min-h-full flex flex-col">
        <div className="grow">
          <SuggestedCourseList />
        </div>
        <Footer />
      </div>
    </main>
  );
}
